document.addEventListener("DOMContentLoaded", function () {
  const uniqueIDInput = document.getElementById("uniqueIDInput");
  const checkUniqueIDBtn = document.getElementById("checkUniqueID");
  const errorMessage = document.getElementById("errorMessage");

  checkUniqueIDBtn.addEventListener("click", async () => {
    const uniqueID = uniqueIDInput.value.trim();
    if (!uniqueID) {
      alert("Please enter a Unique ID.");
      return;
    }

    // ✅ Step 1: Check if it's a known non-personalised game ID
    if (typeof defaultIDs === 'object' && defaultIDs[uniqueID]) {
      console.log("🔐 Matched non-personalised ID:", uniqueID);
      window.location.href = `/pages/np-enter-passcode?uid=${uniqueID}`;
      return;
    }

    // ✅ Step 2: Otherwise, try verifying against Firebase as personalised ID
    try {
      const response = await fetch("https://vaultverification-2qscavuooa-uc.a.run.app/verify-id", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uniqueId: uniqueID }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("📦 Firebase response:", data);

      if (!data.success) {
        errorMessage.style.display = "block";
        return;
      }

      window.location.href = `/pages/enter-passcode?uid=${uniqueID}`;
    } catch (error) {
      console.error("❌ Error verifying Unique ID:", error);
      alert("An error occurred. Please try again.");
    }
  });
});
